<template lang="pug">
  .grouping-job-table
    .table-line.job-grouping-header
      .col.accordion
        span
      .col.check
        label.checkbox
          input(type="checkbox", :checked="checked", :disabled="isGlobalLocked", @click="check")
      .col.job-favorite-header
        span
      .col.company-mark
        span
      .col.company-name
        a(@click="changeOrder('company_name')")
          | 事業所名
          span.sort-icon
            i.fa.fa-caret-down(v-if="order === 'company_name' && orderDirection === 'desc'")
            i.fa.fa-caret-up(v-if="order === 'company_name' && orderDirection === 'asc'")
      .col.company-tel
        span
          | 電話番号
      .col.jobtype-name
        span
          | 募集職種名
      .col.salary
        span
          | 給与
      .col
        a(@click="changeOrder('acquisition_date')")
          | 掲載開始日
          span.sort-icon
            i.fa.fa-caret-down(v-if="order === 'acquisition_date' && orderDirection === 'desc'")
            i.fa.fa-caret-up(v-if="order === 'acquisition_date' && orderDirection === 'asc'")
      .col
        span
          | 掲載終了日
      .col.posting-situation
        span
          | 掲載状況
      .col
        a(@click="changeOrder('media_name')")
          | メディア
          span.sort-icon
            i.fa.fa-caret-down(v-if="order === 'media_name' && orderDirection === 'desc'")
            i.fa.fa-caret-up(v-if="order === 'media_name' && orderDirection === 'asc'")
      .col
        span
        a(@click="changeOrder('article_plan')")
          | 広告金額
          span.sort-icon
            i.fa.fa-caret-down(v-if="order === 'article_plan' && orderDirection === 'desc'")
            i.fa.fa-caret-up(v-if="order === 'article_plan' && orderDirection === 'asc'")
      .col.new
        span
          |
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    props: ['checked'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
      ...mapState({
        order: state => state.searchJob.query.order,
        orderDirection: state => state.searchJob.query.orderDirection,
      }),
    },
    methods: {
      check (event) {
        this.$emit('check', { event })
      },
      changeOrder (field) {
        let newOrderDirection = 'desc'
        if (field === this.order) {
          newOrderDirection = (this.orderDirection === 'desc') ? 'asc' : 'desc'
        }
        this.$emit('searchOrderBy', field, newOrderDirection)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/grouping-job/TableHeader.vue